module.exports = __webpack_public_path__ + "static/media/photograper.1130e92b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/photograper.jpg
// module id = 562
// module chunks = 0